import { connect } from 'react-redux'
import { goBack } from 'connected-react-router'
import { createSelector } from 'reselect'
import SetupMFAWebAuthn from '../../pages/SetupMFAWebAuthn'
import { getUser } from '../../selectors/initialization'
import {
  getStep,
  getErrorCode,
  getIsProcessing,
  getWebAuthnCredential,
  getWebAuthnRegistrationData
} from '../../selectors/setupMFAWebAuthn'
import { getShouldSetupMFA } from '../../selectors/settings'
import {
  prepareWebAuthnRegistration,
  registerWebAuthn,
  finishWebAuthnRegistration
} from '../../actions/setupMFAWebAuthn'
import { withCenteredBaseWithMenu } from '../../components/Base'

export const mapStateToProps = createSelector(
  [
    getUser,
    getWebAuthnRegistrationData,
    getStep,
    getErrorCode,
    getIsProcessing,
    getWebAuthnCredential,
    getShouldSetupMFA
  ],
  (
    user,
    registrationData,
    step,
    errorCode,
    isProcessing,
    credential,
    shouldSetupMFA
  ) => ({
    user,
    registrationData,
    step,
    errorCode,
    isProcessing,
    credential,
    displayLogoutMenuOnly: shouldSetupMFA
  })
)

export const mapDispatchToProps = dispatch => ({
  onCancel: () => dispatch(goBack()),
  onPrepareRegistration: () => dispatch(prepareWebAuthnRegistration()),
  onStartRegistration: () => dispatch(registerWebAuthn()),
  onFinishRegistration: ({ requestId, credential }) =>
    dispatch(finishWebAuthnRegistration({ requestId, credential }))
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withCenteredBaseWithMenu(SetupMFAWebAuthn))
